import {AmountDisplay, Badge, Icon, Typography, cn} from '@sollapay/ui';
import {formatNIS} from '@sollapay/utils';

import type {AmountDisplayProps} from '@sollapay/ui';

interface ActivityAmountBadgeProps extends Pick<AmountDisplayProps, 'amount' | 'variant'> {
  pending?: boolean;
}

export function ActivityAmountBadge({amount, variant, pending = false}: ActivityAmountBadgeProps) {
  if (!pending) return <AmountDisplay amount={amount} variant={variant} />;

  const direction = PENDING_DIRECTION[variant];
  return (
    <Badge
      data-slot="activity-amount-badge"
      variant="outline"
      dir="ltr"
      className="gap-2 border-dashed bg-transparent px-3 py-1.5"
    >
      <Icon name="clock" className="size-4 text-fg-tertiary" />
      <Typography as="span" color="secondary" weight="semibold">
        {formatNIS(amount)}
      </Typography>
      <Icon name={direction.icon} className={cn('size-3.5', direction.color)} />
    </Badge>
  );
}

const PENDING_DIRECTION = {
  credit: {icon: 'arrow-down', color: 'text-fg-credit'},
  debit: {icon: 'arrow-up', color: 'text-destructive'}
} as const;
